module.exports = __webpack_public_path__ + "img/passion-series.03c24e51.png";